<template>
    <div class="choose-type-step">
      <b-container>
        <b-row>
          <b-col>
            <div class="align-self-center text-center">
              <b-img
                  class="logo"
                  :src="logo.path"
                  alt="Main Logo"
              />
              <h5>Welcome!</h5>
              <p class="text-subheading">It looks like you're new to Sellers Shield. Select an option and we'll send you
                right along!</p>
            </div>
          </b-col>
        </b-row>

        <b-form
            @submit.prevent="$emit('submit')"
        >
          <b-row>
            <b-col class="d-md-block"></b-col>
            <b-col cols="12" md="6">
              <b-form-group>

                <div class="option-container"
                     :class="{'is-selected':
                   value.accountType === 'seller'}" @click="onSelect('seller')">
                  <img :src="sellerLogo.path" alt="Homeowner" />
                  <div class="option-text">
                    <p class="text-left"><b>Homeowner</b></p>
                    <p class="text-left">Sell your home and protect the sale</p>
                  </div>
                </div>

                <div class="option-container" :class="{'is-selected': value.accountType === 'agent'}" @click="onSelect('agent')">
                  <img :src="agentLogo.path" alt="Real Estate Professional" />
                  <div class="option-text">
                    <p class="text-left"><b>Real Estate Professional</b></p>
                    <p class="text-left">Help clients complete disclosures and avoid lawsuits</p>
                  </div>
                </div>

                <div class="option-container" :class="{'is-selected': value.accountType === 'transactioncoordinator'}" @click="onSelect('transactioncoordinator')">
                  <img :src="transactionCoordinatorLogo.path" alt="Transaction Coordinator" />
                  <div class="option-text">
                    <p class="text-left"><b>Transaction Coordinator</b></p>
                    <p class="text-left">Connect with agents to send disclosure forms to homesellers.</p>
                  </div>
                </div>

                <!--                    <b-card-->
                <!--                        title="Real Estate Company"-->
                <!--                        title-tag="p"-->
                <!--                        :img-src="brokerLogo.path"-->
                <!--                        img-alt="Image"-->
                <!--                        img-top-->
                <!--                        class="mb-2"-->
                <!--                        :class="{-->
                <!--                            'is-selected': value.accountType === 'broker',-->
                <!--                        }"-->
                <!--                        v-on:click="onSelect('broker')"-->
                <!--                    >-->
                <!--                        <div class="text-center">-->
                <!--                            <b-card-text>-->
                <!--                                Deliver greate service and lower insurance premiums-->
                <!--                            </b-card-text>-->
                <!--                        </div>-->
                <!--                    </b-card>-->

              </b-form-group>
            </b-col>
            <b-col class="d-md-block"></b-col>
          </b-row>


              <b-form-group>
                <div class="justify-content-center">
                  <b-row>
                    <b-col>
                      <p>
                        Select an option to continue
                      </p>
                    </b-col>

                  </b-row>
              <b-row>
                <b-col>
                  <b-btn
                      :disabled="loading"
                      pill
                      size="lg"
                      type="button"
                      class="white-button"
                      @click="goBack"
                  >
                    Back
                  </b-btn>
                  <b-btn
                      :disabled="isNextBtnDisabled"
                      pill
                      size="lg"
                      type="submit"
                      class="gold-button"
                  >
                    Next
                  </b-btn>
                </b-col>
              </b-row>

                </div>
              </b-form-group>


          <div class="align-self-center text-center">

            <!-- a href="#" v-on:click="backToEmail">
                Sign with a different email address
            </a -->
          </div>
        </b-form>

      </b-container>


    </div>
</template>

<script>
import "./ChooseTypeStep.scss";

export default {
    name: 'ChooseTypeStep',
    props: {
        value: {
            type: Object,
            required: true,
            default: () => ({})
        },
        errors: {
            type: Array,
            required: false,
            default: () => ([])
        },
        loading: {
            type: Boolean,
            required: false,
            default: false
        },
    },
    data: () => ({
        
        logo: {
          path: require('@assets/images/ss-wordmark-black.png'),
        },
        sellerLogo: {
            path: require('@assets/images/homeowner2.png'),
        },
        agentLogo: {
            path: require('@assets/images/real-estate-agent2.png'),
        },
        transactionCoordinatorLogo: {
            path: require('@assets/images/transaction-coordinator-icon.png'),
        },
        brokerLogo: {
            path: require('@assets/images/company.png'),
        },
    }),
    computed: {
        isNextBtnDisabled() {
            if (this.value.accountType) {
                return false;
            }

            return true;
        }
    },
    methods: {
        onSelect(value) {
            this.value.accountType = value;
        },
        backToEmail() {
            this.$emit('backToEmail');
        },
      goBack() {
        this.$emit('welcome');
      }
    }
}
</script>

<style scoped>
.is-invalid {
  border-color: red !important;
}

.custom-email-input {
  width: 100%;
  max-width: 600px; /* Adjust this value as needed to match the Figma design */
}

.option-container {
  display: flex;
  align-items: center;
  padding: 15px;
  border-bottom: 2px solid #ccc;
  cursor: pointer;
  background: transparent; /* Transparent background */
}

.option-container:hover {
  border-color: #ccc;
}

.option-container.is-selected {
  background: #EFEADA; /* Selected state color */
  border-color: #E4C763; /* Adjust for selected state */
}

.option-text {
  margin-left: 15px;
}

.option-title {
  font-weight: bold;
}

.selection-text {
  margin-top: 20px;
}

.mt-4 {
  margin-top: 20px;
}
</style>
